module.exports = __webpack_public_path__ + "media/a1.a06cf9dc.mp3";